import { appConfig } from '../../../../config'
import { CaseViewModel } from './types'

export const createCase = async ({
  accessToken,
  message,
}: {
  accessToken: string
  message: string
}): Promise<CaseViewModel> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/portalCase`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ message }),
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to create case')
  }

  return res.json()
}

export const getCase = async ({
  accessToken,
  caseId,
}: {
  accessToken: string
  caseId: string
}): Promise<CaseViewModel> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/portalCase/${caseId}`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to fetch case')
  }

  return res.json()
}

export const markMessageAsRead = async ({
  accessToken,
  messageId,
}: {
  accessToken: string
  messageId: string
}): Promise<void> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/portalCase/message/${messageId}/read`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to mark message as read')
  }
}

export const addMessage = async ({
  accessToken,
  caseId,
  message,
}: {
  accessToken: string
  caseId: string
  message: string
}): Promise<CaseViewModel> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/portalCase/${caseId}/message`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ message }),
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to add message')
  }

  return res.json()
}
